var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _tspan, _path7, _g2, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternationalactivated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 318,
    viewBox: "0 0 318 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_564-2",
    x: 0,
    y: 0,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "International_Component",
    "data-name": "International Component",
    transform: "translate(9 6)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_564-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564-2-2",
    "data-name": "Rectangle 564-2",
    width: 300,
    height: 300,
    transform: "translate(9 6)",
    fill: "#099"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748",
    transform: "translate(710 -176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M-587.523,230.544l3.946,10.19,7.565,6.227,18.132-6.227,16.212,5.1,7.737.188,2.83-10.567-6.227-.008-2.642-7.163-14.719,1.321-2.264-6.038h-12l-2.9-4.718-6.982,3.585-4.734-3.585-9.985,3.774-1.091,7.926Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M-529.3,206.578h3.3l7.114,8.869h7.982l-.943,11.134,4.036,7.31h6.626l8.118,3.544,9.242,6.412-13.209-30-5.661-14.907-30,1.7-4.623,8.209Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M-511.853,268.851l-1.7,9.623,7.507,3.02h3.815l5.6,9.54,7.706-4.351,3.4-9.435,3.208-11.511,1.321-9.058-12.643,4.34-4.315-8.254-13.706,2.688Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M-501.191,233.891l-9.53,7.6-8.869,4.718,7.926,9.247,13.681-2.737,4.057-7.831,10.1-1.038-9.242-6.412Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M-531.1,235.45l-2.83,10.567,2.83,2.265,5.563,1.509,4.816-9.057,3.774.943-2.642,4.529,8.869-4.718,9.53-7.6h-6.626l-4.036-7.31.943-11.134h-7.982l-6.17,6.039-7.171-1.51-7.737,8.3,2.642,7.163Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M-578.843,222.429l6.982-3.585,2.9,4.718h12l2.264,6.038,14.719-1.321,7.737-8.3,7.171,1.51,6.17-6.039-7.114-8.869h-3.3l-8.024,2.265,4.623-8.209-12.266,10.945-16.983,3.963-16.8-.577-4.828,3.879Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M-539.5,305.176l18.3-1.132,7.359-6.227,13.21-4.529,3.993-2.254-5.6-9.54h-3.815l-7.507-3.02H-526.2l-8.106,9.247-19.436-1.132-4.529-9.058h-14.448l-12.537,28.494,4.11,4.99,17.874-15.274Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M-511.664,255.453l-7.926-9.247,2.642-4.529-3.774-.943-4.816,9.057-5.538,7.171,3.56,9.247-8.869,1.321-9.057-4.152-14.342,6.227,1.51,7.926,4.529,9.058,19.436,1.132,8.106-9.247h12.652l1.7-9.623Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M-533.931,246.017l-7.737-.188-16.212-5.1-5.095,9.057-6.646,7.171,9.837,12.643,14.342-6.227,9.057,4.152,8.869-1.321-3.56-9.247,5.538-7.171-5.563-1.509Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M-578.843,290.551l6.121-13.02-21.931,3.987-7.023,10.921,7.023,1.264-1.173,9.492-18.116,1.132-9.341,7.265,1.321,8.68,2.642,2.642,12.077,1.132,12.832-1.7,13.262-11.333-4.11-4.99Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M-569.621,256.962l6.646-7.171,5.095-9.057-18.132,6.227-18.641,2.83,1.329,7.171,6.933,2.642-3.586,8.869-14.53,1.132-3.585,10.945,6.416,11.889,7.023-10.921,21.93-3.987h14.449l-1.51-7.926Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M-586.391,259.6l-6.933-2.642-1.329-7.171,18.641-2.83-7.565-6.227-3.946-10.19h-7.13l1.091-7.926-14.53.861-4.505,15.179,8.09,5.189-1,7.265h-3.529l-2.075,11.323,6.6,7.17,14.53-1.132Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M-632.09,215.447l-7.516,2.378v9.511l9.731,2.264,2.724-9.058,14.554-5.425,4.505,8.362,14.53-.861,9.985-3.774,4.828-3.879V196.1l-5.85-6.227-23.21,3.4-25.664,15.1-6.793-1.415,1.981,3.962Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M-654.907,243.847l6.243-1.038-2.453-7.737,11.511-7.736v-9.511l7.516-2.378-6.195-4.529-1.981-3.962v-3.3l-17.172,6.6-6.794.189.567,11.133,4.717,7.36-.833,6.651Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M-669.8,248.47l14.891-4.623-4.874-8.256.833-6.651-9.435,5.661-7.548-3.208-14.53,11.322,3.4,16.606,12.221-15.474Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M-604.507,243.847l-8.09-5.189,4.505-15.179-4.505-8.362-14.554,5.425-2.724,9.058-9.731-2.264-11.511,7.736,2.453,7.737,5.941,6.982,2.457,7.171h18.809l12.421-5.85h3.529Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M-595.826,303.2l1.173-9.492-7.023-1.264-6.416-11.889,3.585-10.945-6.6-7.17,2.075-11.323-12.421,5.85-6.355,21.9,4.529,8.861-7.076,6.6-18.4-9.341-4.151,4.717,14.152,9.624,15.474,12.266,9.341-7.265Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M-623.283,287.721l-4.529-8.861,6.355-21.9h-18.809l-2.457-7.171-5.941-6.982-6.243,1.038L-669.8,248.47l5.566,10.851.378,23.965,13.586-3.585,1.51,5.284,18.4,9.341Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M-669.8,248.47l-5.046-4.623-12.221,15.474-9.435,17.738,3.019,14.153,6.416,8.869,9.435-.723v-7.014l13.776-9.058-.378-23.965Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(710 -186)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M-535.741,345.2l-19.715,1.22-7.926,6.707-14.227,4.878-4.3,2.428,6.028,10.275h4.109l8.086,3.252h13.626L-541.33,364l20.934,1.219,4.878,9.756h15.562l13.5-30.69-4.426-5.375-19.252,16.452Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M-565.719,398.757l8.536,9.959-2.846,4.878,4.065,1.017,5.187-9.756,5.965-7.723-3.835-9.959,9.553-1.423,9.755,4.471,15.447-6.707-1.626-8.536-4.878-9.756L-541.33,364l-8.731,9.959h-13.626l-1.829,10.365Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M-541.737,408.92l8.333.2,17.462,5.488,5.487-9.756,7.158-7.723-10.6-13.618-15.447,6.707-9.755-4.471-9.553,1.423,3.835,9.959-5.965,7.723,5.992,1.626Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M-493.364,360.954l-6.592,14.024,23.62-4.295,7.564-11.762-7.564-1.361,1.264-10.224,19.511-1.219,10.061-7.825-1.423-9.349-2.845-2.846-13.008-1.219-13.821,1.829-14.283,12.206,4.426,5.375Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M-503.3,397.132l-7.158,7.723-5.487,9.756,19.529-6.707,20.077-3.049-1.431-7.723-7.467-2.846,3.861-9.552,15.65-1.22,3.862-11.788-6.91-12.805-7.565,11.762-23.62,4.295h-15.562l1.626,8.536Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M-485.234,394.286l7.467,2.846,1.431,7.723-20.077,3.049,8.147,6.707,4.251,10.975h7.679l-1.175,8.536,15.65-.928,4.851-16.348-8.713-5.589,1.077-7.825h3.8l2.236-12.2-7.114-7.723-15.65,1.22Z",
    fill: "#005e84",
    stroke: "#099",
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M-614.483,234a24.2,24.2,0,0,0-24.2,24.2c0,10.495,14.919,26.889,21.329,33.444a4,4,0,0,0,5.662.077c.026-.025.051-.051.076-.077,6.408-6.556,21.327-22.949,21.327-33.444A24.2,24.2,0,0,0-614.483,234Zm0,35.392a11.794,11.794,0,0,1-11.792-11.8,11.793,11.793,0,0,1,11.8-11.792A11.794,11.794,0,0,1-602.688,257.6a11.793,11.793,0,0,1-11.795,11.793Z",
    transform: "translate(707 -182.464)",
    fill: "#005e84",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "International",
    transform: "translate(710 -186)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "International-2",
    "data-name": "International",
    transform: "translate(-560 464.75)",
    fill: "#fff",
    fontSize: 48,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600,
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -135.264,
    y: 0
  }, "International")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746-2",
    "data-name": "Group 2746",
    transform: "translate(710 -186)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753-2",
    "data-name": "Path 1753",
    d: "M-535.741,345.2l-19.715,1.22-7.926,6.707-14.227,4.878-4.3,2.428,6.028,10.275h4.109l8.086,3.252h13.626L-541.33,364l20.934,1.219,4.878,9.756h15.562l13.5-30.69-4.426-5.375-19.252,16.452Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754-2",
    "data-name": "Path 1754",
    d: "M-565.719,398.757l8.536,9.959-2.846,4.878,4.065,1.017,5.187-9.756,5.965-7.723-3.835-9.959,9.553-1.423,9.755,4.471,15.447-6.707-1.626-8.536-4.878-9.756L-541.33,364l-8.731,9.959h-13.626l-1.829,10.365Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755-2",
    "data-name": "Path 1755",
    d: "M-541.737,408.92l8.333.2,17.462,5.488,5.487-9.756,7.158-7.723-10.6-13.618-15.447,6.707-9.755-4.471-9.553,1.423,3.835,9.959-5.965,7.723,5.992,1.626Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757-2",
    "data-name": "Path 1757",
    d: "M-493.364,360.954l-6.592,14.024,23.62-4.295,7.564-11.762-7.564-1.361,1.264-10.224,19.511-1.219,10.061-7.825-1.423-9.349-2.845-2.846-13.008-1.219-13.821,1.829-14.283,12.206,4.426,5.375Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2",
    "data-name": "Path 1756",
    d: "M-503.3,397.132l-7.158,7.723-5.487,9.756,19.529-6.707,20.077-3.049-1.431-7.723-7.467-2.846,3.861-9.552,15.65-1.22,3.862-11.788-6.91-12.805-7.565,11.762-23.62,4.295h-15.562l1.626,8.536Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758-2",
    "data-name": "Path 1758",
    d: "M-485.234,394.286l7.467,2.846,1.431,7.723-20.077,3.049,8.147,6.707,4.251,10.975h7.679l-1.175,8.536,15.65-.928,4.851-16.348-8.713-5.589,1.077-7.825h3.8l2.236-12.2-7.114-7.723-15.65,1.22Z",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1779",
    "data-name": "Path 1779",
    transform: "translate(709.001 -184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M-464.91,366h0a5.327,5.327,0,0,1-3.588-1.392l-12.846-11.7-12.845,11.7h0A5.321,5.321,0,0,1-497.777,366a5.309,5.309,0,0,1-1.922-.358,5.35,5.35,0,0,1-2.282-1.673,5.353,5.353,0,0,1-1.093-2.612,5.341,5.341,0,0,1,.379-2.8,5.343,5.343,0,0,1,1.773-2.208l12.984-9.441-7.855-7.153a3.287,3.287,0,0,1-1.023-3.052h0v0a3.287,3.287,0,0,1,2.06-2.472,3.271,3.271,0,0,1,1.189-.223,3.282,3.282,0,0,1,1.944.634l10.278,7.474,10.276-7.472a3.272,3.272,0,0,1,1.944-.635,3.317,3.317,0,0,1,1.188.22h0a3.283,3.283,0,0,1,2.061,2.472,3.282,3.282,0,0,1-1.021,3.055l-7.856,7.154,12.984,9.442a5.343,5.343,0,0,1,1.773,2.207,5.336,5.336,0,0,1,.38,2.8,5.352,5.352,0,0,1-1.093,2.613,5.353,5.353,0,0,1-2.283,1.673A5.323,5.323,0,0,1-464.91,366Z",
    fill: "#005e84",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M-611.5,295.2s106.374-86.074,129.156,35.093",
    transform: "translate(710 -176)",
    fill: "none",
    stroke: "#ffb703",
    strokeWidth: 10,
    strokeDasharray: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalactivated);
export default __webpack_public_path__ + "static/media/internationalactivated.acb929e9dbbb7124f53026c23d227150.svg";
export { ForwardRef as ReactComponent };